import { render, staticRenderFns } from "./ReportIndexComponent.vue?vue&type=template&id=bb3fc128"
import script from "./ReportIndexComponent.vue?vue&type=script&lang=js"
export * from "./ReportIndexComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports